import React from 'react'
import { useDefaultInputStyles } from '../hooks/defaultInputStylesHook'
import { BootstrapInput } from './BootstrapInput'

export type PropFilterItemBase = {
  readOnly: boolean

  placeholder: string

  value: string | undefined

  setValue: (filterValue: string | undefined) => void
}

export type StringPropFilterItem =
  PropFilterItemBase & {
  isBoolean?: false
}

export const StringPropFilter =
  ({placeholder, readOnly, value, setValue}: StringPropFilterItem) => {
    const classes = useDefaultInputStyles()

    return (
      <BootstrapInput
        type="text"
        className={classes.input}
        readOnly={readOnly}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={e => setValue(e.target.value)}/>
    )
  }